import { apiGetJobsForListing } from 'app/api_v2/jobs';
import { RootState } from 'app/store/rootReducer';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import LinesSkeleton from 'app/ui_v2/components/skeletons/lines-skeleton/LinesSkeleton';
import { parseFormValuesToParams, parseSearchParams } from 'app/ui_v2/form-utils';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Box, Card, CardContent, Container, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import BookingsData from './bookings-data/BookingsData';
import BookingsSearchForm from './bookings-search-form/BookingsSearchForm';
import { FormValues } from './bookings-search-form/validation-schema';

export default function ProjectsListingPage() {
  const { user } = useSelector((state: RootState) => state.auth);

  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsString = searchParams.toString();
  const parsedSearchParams = parseSearchParams(searchParams);

  const queryKey = ['backoffice-projects-list/get', searchParamsString];

  const { isLoading, isFetching, isError, error, data } = useQuery({
    queryKey,
    queryFn: ({ signal }) => apiGetJobsForListing(parsedSearchParams, signal),
    keepPreviousData: true,
  });

  const handleSearch = (v: FormValues) => {
    setSearchParams(parseFormValuesToParams({ ...v, page: '1' }));
  };

  if (!user) {
    return null;
  }

  return (
    <Container maxWidth="lg">
      <Box pt={4} pb={2}>
        <Typography component="h2" variant="h1">
          Projects
        </Typography>
      </Box>
      <BookingsSearchForm
        onFormChange={handleSearch}
        onFormSubmit={handleSearch}
        isLoading={isLoading}
        ifReset={0}
        defaults={parsedSearchParams as FormValues}
      />

      {data && (
        <BookingsData
          data={data.results}
          isFetching={isFetching || isLoading}
          page={parsedSearchParams?.page || '1'}
          totalPages={data.totalPages}
          onPageChange={(page: string) => {
            setTimeout(() => {
              setSearchParams((currentValues) => {
                return { ...parseSearchParams(currentValues), page };
              });
            }, 300);
          }}
        />
      )}

      {isLoading && !isError && (
        <Card>
          <CardContent>
            <Box mb={4}>
              <LinesSkeleton elements={4} isWithButtons={false} lineHeight={35} />
            </Box>
          </CardContent>
        </Card>
      )}
      {isError && error && <ErrorsList title="Unexpected loading error" errors={error as string[]} />}
    </Container>
  );
}
